module.exports = __webpack_public_path__ + "static/amazonWhiteDeu-f6a8c03442893c6e2187c7fde18be690.svg";